import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalMedia() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Media & Broadcast: Revolutionizing Content Production with 5G
          Sub-6 or mmWave
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Deliver seamless, high-quality content with FlexNet’s private 5G
          solutions for media and broadcasting.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">FlexNet Media</span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Transform your media production with FlexNet’s low-latency,
              high-bandwidth private 5G networks. Enhance content creation,
              streamline editing, and ensure secure, real-time collaboration.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://images.stockcake.com/public/6/c/f/6cf809c9-2dae-46ee-9a5c-c7d029870776_large/drone-filming-scene-stockcake.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Media & Broadcast?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Manufacturing </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>

            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600">Testimonials/Case Studies</span>
        </div>
        <div className="grid justify-center">
          <div className="col-12 md:col-4 mb-4 px-5">
            <div className="text-900 text-xl mb-3 font-medium">
              Success Stories in Media & Broadcast
            </div>
            <div className=" vertical-testimonials">
              <div className="text-700 line-height-3 vertical-testimonials-box text-xl">
                <span className="text-blue-600">
                  Special Olympics in Germany Problem:
                </span>{" "}
                Delays and connectivity issues during live event streaming.
                <br />
                <br />
                <span className="text-blue-600"> Solution:</span> FlexNet
                private 5G deployment for seamless, high-quality streaming.
                Outcome: Improved live streaming quality, reduced latency, and
                enhanced audience experience.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Elevate Your Media Production?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Enhanced Content Production",
    detail: "Enable real-time data transfer for seamless media workflows.",
    icon: "pi pi-play ",
  },
  {
    title: "Wireless Studio Connectivity",
    detail: "Flexible and mobile production setups with private 5G.",
    icon: "pi pi-wifi",
  },
  {
    title: "Low-Latency Streaming",
    detail: "Ensure smooth, real-time live broadcasting.",
    icon: "pi pi-video",
  },
  {
    title: "Seamless AR/VR Integration",
    detail: "Enhance viewer experiences with immersive media.",
    icon: "pi pi-eye",
  },
  {
    title: "Secure Data Transfer & Network Slices",
    detail: "Ensure isolated and prioritized data for critical operations.",
    icon: "pi pi-lock",
  },
];

const useCases = [
  {
    title: " 1: Content Production with Seamless Data Transfer",
    description:
      "Enable seamless data transfer between cameras, drones, and editing teams using FlexNet’s high-speed private 5G networks.",
    benefits: [
      { title: "Faster content delivery", icon: "pi pi-forward" },
      { title: "Simplified production workflows", icon: "pi pi-sync" },
      { title: "Enhanced collaboration between teams", icon: "pi pi-users" },
    ],
    devices: [
      { title: "5G Cameras", icon: "pi pi-camera" },
      { title: "Drones", icon: "pi pi-send" },
      { title: "Edge Computing Servers", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Media Production Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 2: Real-Time Editing with Edge Computing",
    description:
      "Utilize edge computing for immediate content processing and real-time editing during live broadcasts.",
    benefits: [
      { title: "Minimize latency for faster edits", icon: "pi pi-clock" },
      {
        title: "Enhance production quality with real-time adjustments",
        icon: "pi pi-star",
      },
      { title: "Support complex workflows on-the-go", icon: "pi pi-cog" },
    ],
    devices: [
      { title: "Edge Servers", icon: "pi pi-server" },
      { title: "High-Performance Workstations", icon: "pi pi-desktop" },
    ],
    applications: [
      { title: "Real-Time Editing Software", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 3: Remote Control and Monitoring of Media Equipment",
    description:
      "Connect smart cameras and audio devices via private 5G for remote control and monitoring from any location.",
    benefits: [
      { title: "Increase operational flexibility", icon: "pi pi-arrows-h" },
      { title: "Reduce on-site crew requirements", icon: "pi pi-user-minus" },
      { title: "Enhance equipment management and control", icon: "pi pi-cog" },
    ],
    devices: [
      { title: "5G Cameras", icon: "pi pi-camera" },
      { title: "Audio Equipment", icon: "pi pi-volume-up" },
      { title: "IoT Monitoring Platforms", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Remote Media Control Solutions", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 4: High-Bandwidth Movie Making with 8K+ Video Streaming",
    description:
      "Leverage high-bandwidth private 5G networks for 8K and higher-resolution video streaming during film shoots.",
    benefits: [
      {
        title: "Ensure seamless high-quality video capture",
        icon: "pi pi-video",
      },
      {
        title: "Enable real-time feedback during shoots",
        icon: "pi pi-comments",
      },
      {
        title: "Prioritize critical devices with network slicing",
        icon: "pi pi-table  ",
      },
    ],
    devices: [
      { title: "8K Cameras", icon: "pi pi-camera" },
      { title: "5G Network Slicing", icon: "pi pi-globe" },
      { title: "Edge Processing Units", icon: "pi pi-server" },
    ],
    applications: [
      { title: "High-Bandwidth Streaming Solutions", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: AR/VR Production Over 5G",
    description:
      "Integrate AR/VR production setups with low-latency private 5G networks for immersive media experiences.",
    benefits: [
      { title: "Real-time rendering and feedback", icon: "pi pi-cog" },
      {
        title: "Seamless integration of virtual elements into live content",
        icon: "pi pi-image",
      },
      { title: "Enhanced viewer engagement", icon: "pi pi-users" },
    ],
    devices: [
      { title: "AR/VR Headsets", icon: "pi pi-eye" },
      { title: "5G Edge Servers", icon: "pi pi-server" },
      { title: "Real-Time Graphics Software", icon: "pi pi-desktop" },
    ],
    applications: [
      { title: "AR/VR Media Production Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 6: RT Protocols for Audio/Video Synchronization",
    description:
      "Replace traditional wired setups with synchronized 5G-enabled wireless transmitters for audio and video channels.",
    benefits: [
      {
        title: "Ensure precise synchronization of audio and video",
        icon: "pi pi-volume-up",
      },
      {
        title: "Increase mobility and flexibility in production",
        icon: "pi pi-arrow-right-arrow-left",
      },
      { title: "Reduce cabling and setup time", icon: "pi pi-eraser" },
    ],
    devices: [
      { title: "Wireless Audio/Video Transmitters", icon: "pi pi-wifi " },
      { title: "Edge Servers", icon: "pi pi-server" },
    ],
    applications: [
      {
        title: "Real-Time Audio/Video Processing Platforms",
        icon: "pi pi-desktop",
      },
    ],
  },
];
